__turbopack_context__.v({
  "checkbox": "ApplyOpenCallNotes-module__xBuFha__checkbox",
  "checkboxIcon": "ApplyOpenCallNotes-module__xBuFha__checkboxIcon",
  "column": "ApplyOpenCallNotes-module__xBuFha__column",
  "columns": "ApplyOpenCallNotes-module__xBuFha__columns",
  "container": "ApplyOpenCallNotes-module__xBuFha__container",
  "error": "ApplyOpenCallNotes-module__xBuFha__error",
  "fadeInItems": "ApplyOpenCallNotes-module__xBuFha__fadeInItems",
  "requirement": "ApplyOpenCallNotes-module__xBuFha__requirement",
  "requirementTitle": "ApplyOpenCallNotes-module__xBuFha__requirementTitle",
  "spacing--lg": "ApplyOpenCallNotes-module__xBuFha__spacing--lg",
  "spacing--md": "ApplyOpenCallNotes-module__xBuFha__spacing--md",
  "spacing--sm": "ApplyOpenCallNotes-module__xBuFha__spacing--sm",
  "spacing--xl": "ApplyOpenCallNotes-module__xBuFha__spacing--xl",
  "spacing--xs": "ApplyOpenCallNotes-module__xBuFha__spacing--xs",
  "spacing--xxl": "ApplyOpenCallNotes-module__xBuFha__spacing--xxl",
  "spacing--xxs": "ApplyOpenCallNotes-module__xBuFha__spacing--xxs",
  "spacing--xxxl": "ApplyOpenCallNotes-module__xBuFha__spacing--xxxl",
  "spacing--xxxs": "ApplyOpenCallNotes-module__xBuFha__spacing--xxxs",
  "text": "ApplyOpenCallNotes-module__xBuFha__text",
  "title": "ApplyOpenCallNotes-module__xBuFha__title",
});
